import { useEffect } from 'react';

// Overlays each used to write document.body.style.overflow directly and blank
// it on cleanup, so whichever closed last unlocked the page even when another
// was still open — a preview closing inside a dialog that stays up. Counting
// holders is what stops one overlay releasing another's lock.
//
// The last holder blanks rather than restoring whatever it found. Restoring the
// captured value looks tidier but is unsafe while any writer outside this
// counter still locks the body: this can capture their 'hidden', and then write
// 'hidden' back after they have already unlocked, stranding the page
// unscrollable with nothing on screen. MUI's own ModalManager is still such a
// writer (StudentSubscription.tsx), so blanking is the honest contract until
// #1370 moves the overlays off hand-rolled locks.
//
// Modal, Drawer, the download preview and the dashboard drill-down all hold
// this lock through useOverlayLayer (lib/overlayStack.ts), which owns Escape
// routing only — this is the one counter.
// Deliberately not exported: the only way to take the lock is to mount a
// component that wants it, so holders cannot drift to a floor above zero and
// strand the page locked for the rest of the session.
let holders = 0;

const acquire = () => {
  holders += 1;
  if (holders > 1) return;
  document.body.style.overflow = 'hidden';
  document.body.style.overscrollBehavior = 'none';
};

const release = () => {
  if (holders === 0) return;
  holders -= 1;
  if (holders > 0) return;
  document.body.style.overflow = '';
  document.body.style.overscrollBehavior = '';
};

export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    acquire();
    return release;
  }, [active]);
}
